import React, { useState, useEffect } from 'react';
import {
  CCard,
  CCol,
  CRow,
  CCardBody,
} from '@coreui/react'
import * as wjcGrid from "@grapecity/wijmo.grid";
 import SplitPane from 'react-split-pane';
import './document.css';
 import { Document, Page, pdfjs } from 'react-pdf';
 import { doc_styles } from "./documentDetailStyle";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router";
import moment from 'moment';
import settings from '../../config/settings';
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
 import { ToastContainer, toast } from 'react-toastify';
 import 'react-toastify/dist/ReactToastify.min.css';
import 'react-toastify/dist/ReactToastify.min.css';
 import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';
import * as wjFilter from "@grapecity/wijmo.react.grid.filter";
 import * as wjGrid from "@grapecity/wijmo.grid";
import '@grapecity/wijmo.styles/wijmo.css';
 import Grid from "@material-ui/core/Grid";
 import { withStyles } from "@material-ui/core/styles";
import { useSelector} from 'react-redux';
import { GroupPanel } from "@grapecity/wijmo.react.grid.grouppanel";
 import { handleApiError } from '../../session/session-expire';
import shadows from '@material-ui/core/styles/shadows';
import { Box, Checkbox, FormControlLabel, InputLabel,IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import IssueHistoryData from './IssueHistoryData';
 
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.js`;

const master_dropdown={
  width: "200px",
  background: "grey",
  outline:'none',
  borderRadius:'2px',
  border:"none",
  fontSize: "11px",
  padding: "8px 0",
  marginTop:"0px",
  marginLeft:"10px",
}
const table_header = {
   color: "#000000",
  fontSize: 12,
  fontWeight: 'bold'
}
const table_headerMain = {
  borderBottom: "none",
 color: "#2352a2",
 fontSize: 10,
 paddingTop:"0",
 paddingBottom:"0"
 }
const table_content = {
   color: "rgb(142, 142, 142)",
  fontSize: 12,
  width: 200
}
const loader = {
  position: "fixed",
  top: "0",
  left: "0",
  right: "0",
  bottom: "0",
  background: "rgba(255,255,255,0.4)",
  zIndex: "9999",
  display: "table",
  width: "100%",
  height: "100%"
}
const cancel_dialogBtn = {
  fontSize: 14,
  color: 'white',
  background: 'none', 
          fontSize: "24px",
          color: "#fff",
          position: "absolute",
          top: "4px",
          right:"0"
}
const cancel_dialogValidateBtn = {
  backgroundColor: '#4EA7D8',
  fontSize: 14,
  color: 'white',
  marginRight:20,
  marginBottom:10
}
const submit_dialogBtn = {
  backgroundColor: '#4EA7D8',
  fontSize: 14, color: 'white',
  marginRight: "15px"
}

const resolve_dialogBtn = {
  backgroundColor: 'rgb(255, 255, 255)',
  boxShadow:'rgba(0, 0, 0, 0.4) 1px 1px 3px',
  fontWeight:'600',
  fontSize:'10px',
  padding:'4px 8px',
   marginLeft:'15px',
  marginTop:'5px',
   
}
const resolve_popup_dialogBtn = {
  backgroundColor: 'rgb(255, 255, 255)',
  boxShadow:'rgba(0, 0, 0, 0.4) 1px 1px 3px',
  // fontWeight:'600',
  fontSize:'13px',
  padding:'4px 8px',
   marginLeft:'15px',
  marginTop:'5px',
   
}

const topMenu={
  background: "rgb(131,73,191)",
  background: "linear-gradient(-90deg, rgba(131,73,191,1) 16%, rgba(25,229,246,1) 84%)",
  marginTop:'120px',
  position:'fixed'
}
const cardView = {
  backgroundColor: 'transparent',
  border: 0,
  top:140  
}
const pdfContentView = {
  boxShadow: '0px 4px 32px 1px #00000029',
   maxHeight: 800,
  marginTop: 10,
  marginLeft: 'auto',
  marginRight: 'auto'
}
const bottom_View = {
  backgroundColor: '#fff',
  maxHeight: 600,
  borderTop:"#ccc solid 1px" ,
 }
const dateTimeView = {
  fontSize: 12,
   margin:0,
  whiteSpace:"nowrap"

 }
const viewDetailBtn = {
  background: 'none',
  fontSize: "1em",
  color: '#999',
  whiteSpace: "nowrap",
  margin: "0 10px",
  cursor:'pointer'
}
const issueBtn = {
  backgroundColor: 'red',
  fontSize: 14,
  color: 'white',
  whiteSpace: "nowrap",
  margin: "10px"
}
const historyIssueBtn = {
  borderBottom: "none",
  color: "#2352a2",
  fontSize: 10,
  borderLeft: "1px solid #ccc",
  paddingTop:"0",
  paddingBottom:"0"
}
const toast_options = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}
const drag_arrow = {
  textAlign: "center",
  position: "absolute",
  zIndex: "0",
  width: "100%",
  display: "table",
  top: "-20px",
  fontSize: "1.8em",
  color: "#000"
}
const report_block = {
  display: "none",
  marginBottom: "20px",
  position: "fixed",
  zIndex: "1030;",
  right: "8px",
  top: "80px",
  "@media (max-width: 1200px)": {
    top: '135px'
  }
}
const report_title = {
  fontSize: "1em",
  color: "#fff",
  textAlign: "right",
  fontWeight: "700",
  margin: "0 20px 20px 0",
  cursor: "pointer",
  width:200, 
}
const report_box= {
  width: "25%",
  background: "url(./list_icon.png) no-repeat",
  backgroundSize: "35px",
  backgroundPosition: "50% 0",
  padding: "50px 15px 0 15px",
  color: "#fff",
  display: "block",
  textAlign: "center",
  fontSize: "0.7em",
  boxShadow: "1px 0px 0 #fff",
  float: "left"
}
const title_text = {
  color: 'white', 
  position: "fixed", 
  width:"100%",
  top: "106px", 
  left: "12px", 
  zIndex: "1030", 
  fontWeight: "bold",
   padding:"8px 30px",
  background: 'rgb(115, 115, 115)',
  fontSize: '12px',
  borderTop: '1px solid #a8a8a8',
"@media (max-width: 1200px)": {
  top: '135px'
}}
const zoomRotate_Icon ={
  borderRadius: "50px", 
  width: "30px", 
   textAlign: "center", 
   color: "#486fb4", 
  display: "table-cell", 
  cursor: "pointer",
  fontSize: "1.3em"
}


const DocumentDetails = (props) => {   
  const history = useHistory();
    const [open, setOpen] = React.useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [Isloader, setIsloader] = useState(false);
  const [openReportIssue, setOpenReportIssue] = React.useState(false);
   const [enterIssue, setEnterIssue] = useState("")
  const [isCsvLoading, setIsCsvLoading] = useState(false);
  const [finalDataResult, setFinalDataResult] = useState([]);
  const [pdfImage, setPdfImage] = useState('');
  const [fileType, setFileType] = useState('pdf');
  const [pageNo, setPageNo] = useState(1);
  const [expandScreen, setExpandScreen] = useState(false);
   const [pageNoToShow, setPageNoToShow] = useState("1");
  const [docValidated, setDocValidated] = useState("No");
  const [Toggle, setToggle] = useState(false);
  const [gridObject, setGridObject] = useState();
  const [isPageChange, setIsPageChange] = useState('');
   const [csvFileName,setCsvFileName]=useState('')
  const [openValidateData, setOpenValidateData] = React.useState(false);
  const [validData, setValidData] = useState({});
  const [reportIsuueCells, setReportIsuueCells] = useState([]);
   const [flagissue,setFlagIssue]=useState(false)
   const [rotate, setRotate] = useState(0);
  const [canvasBackground, setCanvasBackground] = useState(null);
   const [externalLinkTarget, setExternalLinkTarget] = useState(null);
  const [file, setFile] = useState(null);
  const [fileForProps, setFileForProps] = useState(null);
   const [pageHeight, setPageHeight] = useState(null);
   const [pageScale, setPageScale] = useState(null);
  const [pageWidth, setPageWidth] = useState(null);
    const [renderAnnotationLayer, setRenderAnnotationLayer] = useState(true);
  const [renderForms, setRenderForms] = useState(true);
  const [renderMode, setRenderMode] = useState('canvas');
  const [renderTextLayer, setRenderTextLayer] = useState(true);
  const [openReportResolve, setOpenReportResolve] = React.useState(false);
  // const [issueResolved, setIssueResolved] = useState(false);
  const [selectedReportIssueCells, setSelectedReportIssueCells] = useState([])
  const[selectissue,setSelectresolveissue]=useState([])
   const [docState,setDocState]=useState("")
    const [openDialogs, setOpenDialog] = useState(false);
// const[updateIssueHistory,setUpdateIssueHistory]=useState([])
const[issueHistoryData,setIssueHistoryData]=useState([])
 
    const compId = useSelector(state => state.companyId)
     let details = localStorage.getItem("details");
 if (details) {
  try {
    details = JSON.parse(details);
   } catch (error) {
    console.error("Error parsing JSON from local storage:", error);
    details = null;
  }
} else {
  console.log("No details found in local storage.");
}
 
    useEffect(() => {
    
      localStorage.setItem('splitPos', 660)
    let details = JSON.parse(localStorage.getItem("details"))
     if (history && history?.location && history?.location.state) {
      
      // let docValidatedRec = history?.location.state.docStatus? history?.location.state.docStatus.toLowerCase() === "validated"?"Yes":"No":"No";
      // setDocValidated(docValidatedRec)
 
      // let reportIsuueCellsRec = history?.location.state.errMsg || [];
      //  setReportIsuueCells(reportIsuueCellsRec);

      // setIssueResolved(history?.location.state.issue_resolved);
      setDocState(history?.location.state && history?.location.state.docStatus)

    }
    
    else if (details) {
       history.location.state = details
    }
    
    console.log('final_filenames in useEffect :>>', history?.location.state?history?.location.state.final_filenames!==undefined?history?.location.state.final_filenames.length>0?history?.location.state.final_filenames[0]:history?.location.state.finalFileName!==undefined?history?.location.state.finalFileName:"":history?.location.state.finalFileName!==undefined?history?.location.state.finalFileName:"":"");    
  }, [])

  useEffect(() => {
    initializeGrid(gridObject,false,reportIsuueCells, true)
  }, [reportIsuueCells, gridObject])

  useEffect(() => {
    getPdfAndCsv()
  }, [isPageChange])
 
 

  const getPdfAndCsv = () => {
    getPdfImage();
    geCsvData();
  }

  const openDialog = () => {
 
    setOpenReportIssue(true)
  };
  // const handleConfirm = () => {
  //   submitResolve();  
  //   setOpen(false);  
  // };
  console.log("handle confirm====", selectissue)

  
  const handleConfirm = () => {
    if (selectissue.length === 0) {
      toast.warning("Please select at least one issue to resolve.");
      return;
    }
 
    submitResolve()

     setOpen(false);  
  };
  const handleSelectAll = () => {
    if (selectissue.length === reportIsuueCells.length) {
      setSelectresolveissue([]);  
    } else {
      setSelectresolveissue(reportIsuueCells.map((issue) => issue.histId)); 
      
    }
  };
  
  // const resolveDialog=()=>{
  //   if (!selectissue) {
  //     toast.warning("Please select an issue before resolving!");
  //     return;
  //   }
  //   setOpen(true);
  // }
  const resolveDialog = () => {
    if (reportIsuueCells.length === 0) {
      toast.warning("No unresolved issues available!");
      return;
    }
    setOpen(true);
  };
  //   const handleIssueSelection = (histId) => {
  //   setSelectresolveissue((prevSelect) => {
  //     if (prevSelect.includes(histId)) {
  //        return prevSelect.filter((id) => id !== histId);
  //     } else {
  //        return [...prevSelect, histId];
  //     }
  //   });
  // };

  const handleIssueSelection = (histId) => {
    setSelectresolveissue((prevSelect) => {
      // Make sure prevSelect is an array before calling filter
      if (!Array.isArray(prevSelect)) {
        console.error("prevSelect is not an array", prevSelect);
        return []; // Reset to an empty array in case of invalid state
      }
  
      if (prevSelect.includes(histId)) {
        return prevSelect.filter((id) => id !== histId); // Remove from array
      } else {
        return [...prevSelect, histId]; // Add to array
      }
    });
  };
  const clearSelections = () => {
    setSelectresolveissue([]);
  };

  const resolvehandleClose = () => {
     setOpenReportResolve(false)
  };
  const handleClose = () => {
     setOpenReportIssue(false)
    setOpen(false);

  };
  const handleValidateClose = () => {
    setOpenValidateData(false)
  }
  const getPdfImage = () => {
     var pdfFileName = history && history?.location && history?.location.state  && history?.location.state.pdfFilename?history?.location.state.pdfFilename:"";
    var processorPath = history&& history?.location && history?.location.state &&  history?.location.state.processorContainerPath?history?.location.state.processorContainerPath:"";
    var pdfValid = true;
   
    if (pdfFileName) {

    } else {
      pdfValid = false
     }
    if (processorPath) {

    } else {
      pdfValid = false
     }

       setIsloader(true)

      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem('access_token'),
       };
     let  requestBody = { fileName: pdfFileName, containerPath: processorPath+"/pages", fileType: fileType, pageNum: pageNo }
      axios({
        method: "POST",
        url: settings.serverUrl + "/getPdfFile",
        data: JSON.stringify(requestBody),
        headers,
      }).then((response) => {
 
        setIsloader(false)
        if (response.data.err) {
          toast.error(response.data.err, toast_options);
        } else {
          let base64Data = response.data.result.base64Str
          setPdfImage(base64Data)
          setTotalPages(response.data.result.noOfPages)
        }
      }).catch(err => {
        setIsloader(false)
         handleApiError(err, history);
        
      });
    
  }

  const fetchReportHistoryData = () => {
    if(compId){
      getHistoryData()
    }
    else{
      setTimeout(() => {
        toast.warn("Please Select Company", { toast_options });
      }, 1000);
    }
  }

   const geCsvData = (csv_fileName) => {
     var processPath = history?.location.state  && history?.location.state.processorContainerPath ?history?.location.state.processorContainerPath:'';
      setIsCsvLoading(true)
    var dataValid = true;

    let fileName = ""
  
    if(csv_fileName && csv_fileName.length>0){
      fileName = csv_fileName
     }else if(history?.location.state && 
      history?.location.state.final_filenames && 
      history?.location.state.final_filenames.length>0){
        fileName = history?.location.state.final_filenames[0]
 
    }else if(history?.location.state && 
      history?.location.state.finalFileName){
        fileName = history?.location.state.finalFileName
 
    }

    if (fileName) {

    } else {
      dataValid = false
     }
    if (processPath) {

    } else {
      dataValid = false
     }
       const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem('access_token'),
       };
      let requestBody = { fileName: fileName, processorContainerPath: processPath  }
       axios({
        method: "POST",
        url: settings.serverUrl + "/finalData",
        data: JSON.stringify(requestBody),
        headers,
      }).then((response) => {
         if (response.data.err) {
            setIsCsvLoading(false)

        } else {
          setFinalDataResult(response.data.result);
          setIsCsvLoading(false);
          fetchReportHistoryData();
        }

      }).catch(err => {
        setIsCsvLoading(false)
       setIsloader(false)
        handleApiError(err, history);
 
      
      });
   
  }
  //  useEffect(() => {
  //       if(localStorage.getItem("access_token")){
  //       if(compId){
  //         getHistoryData()
  //       }
  //       else{
  //         setTimeout(() => {
  //           toast.warn("Please Select Company", { toast_options });
  //         }, 1000);
  //       }
  //     }
  //     }, [gridObject])

  const getHistoryData = () => {
    // setIsloader(true)
 let userId = localStorage.getItem('userId')
 const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem('access_token'),
 };
let requestBody = {
    company_id: compId,
    user_id: userId,
    fileId:details.doc_id 
   }
 axios({
  method: "POST",
  url: settings.serverUrl + "/getReportHistory",
  data: JSON.stringify(requestBody),
  headers,
}).then((response) => {
   
   
  if (response.data.err) {
     toast.error(response.data.err, toast_options);
  }else{
    if(response.data.result){
      setIssueHistoryData(response.data.result)
      let err_data = []
      response.data.result.map(errObj=>{
        if(errObj.error_status=='Pending'){
          let errmfg = errObj.error_message;
          errmfg['histId']=errObj.hist_id;
          err_data.push(errmfg)
        }
      })
       setReportIsuueCells(err_data);
      //  setUpdateIssueHistory(err_data)
      //  console.log("err_data::::::::::",err_data)
      // initializeGrid(gridObject,false,err_data, true)
    }
  }
  // setIsloader(false)
}).catch(err => {
   if(err.message.includes("403")){
  localStorage.clear();
  history.push("/");
  }
  else{
  toast.error(err.message, toast_options);
  }
});

}

  const submit = () => {
  

    let companyId = localStorage.getItem('companyId')
     let userId = localStorage.getItem('userId')
     if (enterIssue == '' || enterIssue == null || enterIssue == undefined) {
      toast.warn("Please Enter Issue !", toast_options);
    }
    else {
      setIsloader(true)
      let issueCells = selectedReportIssueCells;
      
       const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem('access_token'),
       };
    
      let issue = [];
      let issueData = {issue: enterIssue, reportIsuueCells:issueCells}
       if(reportIsuueCells?.length > 0){
        issue = [...reportIsuueCells, issueData]
      }else{
        issue = [issueData]
      }
 
      setReportIsuueCells(issue);
      let requestBody = {company_id:compId, doc_id: history?.location.state.doc_id, errMsg: issue, user_id: userId }


       axios({
        method: "POST",
        url: settings.serverUrl + "/reportIssue",
        data: JSON.stringify(requestBody),
        headers,
      }).then((response) => {
         setOpenReportIssue(false)
        if (response.data.err) {
          toast.error(response.data.err, toast_options);
        } else {
          toast.success(response.data.result, toast_options);
           setFlagIssue(true)
          // setIssueResolved(false)
          setDocState("Error")
           getHistoryData();
          setEnterIssue("")
        }
        setIsloader(false)
      }).catch(err => {
        setIsloader(false)
         handleApiError(err, history);
       
      });

    }

  }
   
  const submitResolve=()=>{
    setIsloader(true)
  
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem('access_token'),
     };
    let requestBody = {id: history?.location.state.doc_id,histId:selectissue}
     axios({
      method: "POST",
      url: settings.serverUrl + "/resolveIssueList",
      data: JSON.stringify(requestBody),
      headers,
    }).then((response) => {
        if (response.data.err) {
        toast.error(response.data.err, toast_options);
      } else {
        toast.success(response.data.result, toast_options);
        // setIssueResolved(true)
         setDocState("Error")
         setReportIsuueCells([])
         getHistoryData()
        setEnterIssue("")
      }
      setIsloader(false)
    }).catch(err => {
      setIsloader(false)
       handleApiError(err, history);
  
    });


}
   const downloadPdf = () =>{
    var pdfFileName = history?.location.state.pdfFilename;
    var processorPath = history?.location.state.processorContainerPath;
    var pdfValid = true;
   


    if (pdfFileName) {

    } else {
      pdfValid = false
     }
    if (processorPath) {

    } else {
      pdfValid = false
     }

    if (pdfValid) {
        setIsloader(true)

      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem('access_token'),
       };
      axios({
        method: "POST",
        url: settings.serverUrl + "/downloadPdf",
        data: JSON.stringify({ fileName: pdfFileName, containerPath: processorPath }),
        headers,
      }).then((response) => {
 
        setIsloader(false)

        if (response.data.err) {
          toast.error(response.data.err, toast_options);
        } else {
          let base64Data = response.data.result;
          const linkSource = `data:application/pdf;base64,${base64Data}`;
          const downloadLink = document.createElement("a");
          downloadLink.href = linkSource;
          downloadLink.download = pdfFileName;
          downloadLink.click();

        }
      }).catch(err => {
        setIsloader(false)
         handleApiError(err, history);
     
      });
    } else {
 
      setTimeout(() => {
        toast.warn("Request is invalid", toast_options);
     
      }, 500);

    }

  }

  const validateData = () => {
    var docid = history?.location.state.doc_id;
  //  var docStatus=history?.location.state.docStatus;

   // If no issue present 
   if(issueHistoryData?.length === 0){
    toast.warn("There is currently no issues present to validate!", toast_options);
    return;  
   }

   //If all the issues are resolved 
  //  const allResolved = issueHistoryData?.every(item => item.error_status === "Resolved");
  //  if(allResolved){
  //   toast.warn("There is currently no issues present to validate!", toast_options);
  //   return;  
  //  }
  
    const hasPendingIssues = issueHistoryData.some(
      (issue) => issue.error_status === "Pending"
    );


    if (hasPendingIssues) {
      toast.warn("Some issues are still pending. Please resolve them first!", toast_options);
      return;  
    }

  console.log("doc state validated====", docState)
  if(docState==='Validated'){
    toast.warn("All report issues are already validated!",toast_options);
     return;
  }
  // if (docStatus === "Processed") {
  //   toast.warn("Create report issue first, then resolve before validation!",toast_options);
  //   return;
  // }
    if(compId == "619d2b75087f9c908ccf1835"){
      validateDoc()
     }else if (docid.length > 0) {
      validateDocAll(docid)
    }

    else{
      toast.info("Work in progress!", toast_options);
    }
  }

  const validateDoc = () => {
    var processPath = history?.location.state  && history?.location.state.processorContainerPath ?history?.location.state.processorContainerPath:'';
    setIsloader(true)
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem('access_token'),
     };
    let fileName = ""
    if(csvFileName && csvFileName.length>0){
      fileName = csvFileName
    }else if(history?.location.state && 
      history?.location.state.final_filenames && 
      history?.location.state.final_filenames.length>0){
        fileName = history?.location.state.final_filenames[0]
    }else if(history?.location.state && 
      history?.location.state.finalFileName){
        fileName = history?.location.state.finalFileName
    }

     let requestBody = { fileName: fileName, processorContainerPath: processPath }
     axios({
      method: "POST",
      url: settings.serverUrl + "/validateDoc",
      data: JSON.stringify(requestBody),
      headers,
    }).then((response) => {
       if (response.data.err) {
         setIsloader(false)
        toast.error(response.data.err, toast_options);
      } else {
        let validateData = response.data.result;
        setValidData(validateData)
        setDocState("Validated")
        setOpenValidateData(true)
      }
      setIsloader(false)

    }).catch(err => {
       handleApiError(err, history);
    
    });

  }

  const validateDocAll = (docid) => {
    setIsloader(true);
  
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + localStorage.getItem("access_token"),
  };

  const requestBody = { doc_id: docid };

  axios.post(settings.serverUrl + "/validateDocAll", requestBody, { headers })
    .then((response) => {
      setIsloader(false);  

      if (response.data.result) {
        setDocState("Validated");
         toast.success(response.data.result, toast_options);
       } else if (response.data.error || response.data.err) {
        toast.error(response.data.error || response.data.err, toast_options);
      } else {
        toast.warn("Unexpected response format", toast_options);
      }
    })
    .catch((err) => {
      setIsloader(false); 
      handleApiError(err, history);
    });
  }

  const reprocessExtacted=()=>{
    setIsloader(true)
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem('access_token'),
     };
    let requestBody = {doc_id:history?.location.state && history?.location.state.doc_id }
     axios({
      method: "POST",
      url: settings.serverUrl + "/reprocessExtracted",
      data: JSON.stringify(requestBody),
      headers,
    }).then((response) => {
      if (response.data.err) {
        toast.error(response.data.err, toast_options);
        setIsloader(false)
      } else {
        toast.success(response.data.result, toast_options);
        setIsloader(false)
      }
    }).catch(err => {
       setIsloader(false)
      handleApiError(err, history);
      
    });
  
  }
  const exportFileToCSV = (csv, fileName) => {
    var fileType = "txt/csv;charset=utf-8";
    if (navigator.msSaveBlob) {
       navigator.msSaveBlob(
        new Blob([csv], {
          type: fileType,
        }),
        fileName
      );
    } else {
      var e = document.createElement("a");
      e.setAttribute(
        "href",
        "data:" + fileType + "," + encodeURIComponent(csv)
      );
      e.setAttribute("download", fileName);
      e.style.display = "none";
      document.body.appendChild(e);
      e.click();
      document.body.removeChild(e);
    }
  };

  const exportCSV = () => {
    let csvFileNameSplited = history?.location.state.pdfFilename.split(".");
    let csvFileName = csvFileNameSplited[0];
     var rng = new wjGrid.CellRange(
        0,
        0,
       gridObject.rows.length - 1,
       gridObject.columns.length - 1
      ),
      csv = gridObject.getClipString(rng, true, true);
      exportFileToCSV(
      csv,
      csvFileName?csvFileName+".csv":"file_"+new Date().getTime()+".csv",
    );
  };

  const pageDownClicked = () => {
    if(pageNo >= 2){
    let updatedNum = pageNo - 1;
      setPageNo(updatedNum)
    setPageNoToShow(updatedNum)
    setIsPageChange(updatedNum)
     }
    else{
      toast.info("You are already on first page !", toast_options);
    }
  }
  const pageNumberClicked = (data) => {
        if(data <= totalPages){
       let updatedNum = data;
        setPageNo(updatedNum)
       setPageNoToShow(updatedNum)
      
      setIsPageChange(updatedNum)
        
     }
     else{
      toast.info("You are already on last page !", toast_options);
     }
     if(pageNo===totalPages){
      toast.info("You are already on last page !", toast_options); 
     }
   }
  
  const pageUpClicked = () => {
  
    if(pageNo <= totalPages - 1){
    let updatedNum = pageNo + 1;
     setPageNo(updatedNum)
    setPageNoToShow(updatedNum)
    setIsPageChange(updatedNum)
     
  }
  else{
    toast.info("You are already on last page !", toast_options);
  }
}
const sliderClick = () => {
   setToggle(!Toggle)
}

   function getPageProps() {
    return {
      canvasBackground,
      className: 'custom-classname-page',
      height: pageHeight,
      onClick: (event, page) => console.log('Clicked a page', { event, page }),
       renderAnnotationLayer,
      renderForms,
      renderMode,
      renderTextLayer,
      scale: pageScale,
      width: pageWidth,
      customTextRenderer: (textItem) =>
        textItem.str.split('ipsum').reduce(
          (strArray, currentValue, currentIndex) =>
            currentIndex === 0
              ? [...strArray, currentValue]
              : [
                  ...strArray,
                   <mark key={currentIndex}>ipsum</mark>,
                  currentValue,
                ],
          [],
        ),
    };
  }
  const pageProps = getPageProps();
  const documentProps = {
    externalLinkTarget,
    file: fileForProps,
     rotate,
  };
  
    const zoomIn = () => {
      
      if (pageWidth < 612) {
         setPageWidth(612)
        setPageHeight(800)
      }
      else {
         setPageWidth(pageWidth + 30)
        setPageHeight(pageHeight + 30)
      }
    }
    const zoomOut = () => {
      if (pageWidth < 612) {
         setPageWidth(612)
        setPageHeight(800)
      }
      else {
         setPageWidth(pageWidth - 30)
        setPageHeight(pageHeight - 30)
      }
    }
  
    const rotatePdfH = () => {
      setRotate(90)
    }
    const rotatePdfV = () => {
      setRotate(0)
    }
  
    const resetPdf = () => {
      setPageWidth(612)
      setRotate(0)
      setExpandScreen(false)
    }
  
    const expandPdf = () => {
       setExpandScreen(!expandScreen)
       if (pageWidth <= 612) {
         setPageWidth(1600)
        setPageHeight(2000)
      }
      else{
        setPageWidth(612)
        setPageHeight(800)
      }
    }

    // const handleCellClick = (selectedIssue) => {
    //     setSelectresolveissue(selectedIssue?.histId)
    //     console.log("selectedIssue?.histId::",selectedIssue?.histId)
    //  };

    // const handleCellClick = (selectedIssue) => {
    //   if (selectedIssue?.histId) {
    //     setSelectresolveissue(selectedIssue?.histId);
    //     return toast.warning("This issue is already reported.", toast_options);
     
    //    }
    // };
    const handleCellClick = (selectedIssue) => {
      console.log("selected isssueee",selectedIssue)
      setSelectresolveissue(selectedIssue?.histId);
    };
    
    console.log("selectedReportIssueCells",selectedReportIssueCells)
    const handleReportIssue = () => {
      if(selectedReportIssueCells?.length > 0 && selectedReportIssueCells[0]?.topRow == -1){
        toast.warning("Please select atleast one cell to report issue.", toast_options);
      }else if (selectissue?.length === 0) {
         openDialog(); 
      }else{
        toast.warning("This issue is already reported.", toast_options);
      } 
    };
    
 
  const initializeGrid = (flex, status, data, istrue) => {
    console.log("initializeGrid=====", flex, data, istrue)
    if (flex) {
       flex.select(-1, -1); // No cell selected
        setGridObject(flex);
        flex.columnHeaders.rows.defaultSize = 40;
        flex.itemFormatter = function (panel, r, c, cell) {
          if (panel.cellType === wjcGrid.CellType.Cell) {
              console.log("inside the first condition",status, Array.isArray(data), data)
              if (status !== true && Array.isArray(data) && data.length > 0) {
              console.log("inside the second condition")
                  data.forEach(issue => {
                      if (Array.isArray(issue.reportIsuueCells)) {  
                        console.log("inside the third condition",issue.reportIsuueCells)
                          issue.reportIsuueCells.forEach(rng => {
                              for (let rowIdx = rng.topRow; rowIdx <= rng.bottomRow; rowIdx++) {
                                  for (let cIdx = rng.leftCol; cIdx <= rng.rightCol; cIdx++) {
                                      console.log("hardik skdfdddddddddddds",c, cIdx, r, rowIdx)
                                      if (c === cIdx && r === rowIdx) {
                                          cell.innerHTML = `<div class="diff">${cell.innerHTML}</div>`;
                                          cell.addEventListener("click", () => handleCellClick(issue));
                                      }
                                  }
                              }
                          });
                      }  
                  });
              }  
          }
      };
      
    }
};
  
   return (
  <>
  <div style={topMenu}></div>

        <div style={report_block}>
    <h4 style={report_title} onClick={() => sliderClick()}>DOCUMENT REPORT CARD <i class="fa fa-chevron-down" aria-hidden="true"></i></h4>
        {Toggle &&
        <div style={{ width: "400px", padding: "20px", position: "fixed", right: "20px", background: '#8349bf', boxShadow: "0px 4px 6px rgba(0,0,0,0.5)", border: "1px solid #fff", borderRadius: "5px" }}>
                          <div style={report_box}>
                            RECIEVED<br/>
                            {moment(history&& history?.location && history?.location.state && history?.location.state.dateRec).format("MM/DD/YYYY hh:mm A")}
                          </div>
                          <div style={report_box}>
                            PROCESSED<br/>
                            {moment(history && history?.location && history?.location.state && history?.location.state.dateProcessed).format("MM/DD/YYYY")}
                          </div>
                          <div style={report_box}>
                            COMPLETED<br/>
                            12/12/21
                          </div>
                          <div style={report_box}>
                            REPORTED<br/>
                            12/12/21
                          </div>
                        </div>
      }
                        </div>

        <div className='pdf_board'>
        <div className='pdf_header'>
<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24"><path d="M7.98,16.54c0,.47-.41,.86-.89,.86h-.83s0-1.72,0-1.72h.84c.48,0,.89,.39,.89,.86Zm4.11-.86h-.84v3.5s.84,0,.84,0c.48,0,.89-.39,.89-.86v-1.78c0-.47-.41-.86-.89-.86Zm9.91-7.52v10.34c0,3.03-2.47,5.5-5.5,5.5H7.5c-3.03,0-5.5-2.47-5.5-5.5V5.5C2,2.47,4.47,0,7.5,0h6.34c1.47,0,2.85,.57,3.89,1.61l2.66,2.66c1.04,1.04,1.61,2.42,1.61,3.89Zm-12.77,8.38c0-1.16-.96-2.11-2.14-2.11h-1.09c-.55,0-1,.45-1,1v4.44c0,.35,.28,.62,.62,.62s.62-.28,.62-.62v-1.22h.84c1.18,0,2.14-.95,2.14-2.11Zm5,0c0-1.16-.96-2.11-2.14-2.11h-1.09c-.55,0-1,.45-1,1v4.44c0,.35,.28,.56,.62,.56s1.46,0,1.46,0c1.18,0,2.14-.95,2.14-2.11v-1.78Zm4.69-1.57c-.07-.27-.31-.47-.61-.47h-2.31c-.35,0-.62,.28-.62,.62v4.81c0,.35,.28,.62,.62,.62s.62-.28,.62-.62v-1.8h1.24c.35,0,.62-.28,.62-.62s-.28-.62-.62-.62h-1.24v-1.14h1.69c.29,0,.54-.2,.61-.47v-.3Zm.08-2.97v-3h-4c-1.1,0-2-.9-2-2V3H7.5c-1.38,0-2.5,1.12-2.5,2.5v6.5h14Z"/></svg>
{history && history?.location && history?.location.state && history?.location.state && history?.location.state.pdfFilename ? history?.location.state.pdfFilename : ""}

<div className='close_viewer' onClick={()=>history.goBack()}>
  <i class="fa fa-times" aria-hidden="true" style={{ fontSize: '18px'}}></i>
  </div>
        </div>
        <ul className='pdf_sidemenu'>      
            {localStorage.getItem('master') && JSON.parse(localStorage.getItem('master')) &&              
                          <li
                            onClick={() => {
                              localStorage.setItem("details", JSON.stringify(history?.location.state))    
                              history.push({
                                pathname: '/detail/' + history?.location.state.doc_id,
                                state: {
                                  fileName: history?.location.state?history?.location.state.pdfFilename:'',
                                  containerPath: history?.location.state?history?.location.state.processorContainerPath:'',
                                  pageNo : pageNo
                                }
                              })
                            }}>
                              <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
                              <path d="M11,12h6v2h-6v-2ZM21,2V21c0,1.654-1.346,3-3,3H6c-1.654,0-3-1.346-3-3V2h5.171c.413-1.164,1.525-2,2.829-2h2c1.304,0,2.416,.836,2.829,2h5.171Zm-2,2h-5v-1c0-.552-.449-1-1-1h-2c-.551,0-1,.448-1,1v1H5V21c0,.552,.449,1,1,1h12c.551,0,1-.448,1-1V4Zm-8,6h6v-2h-6v2Zm0,8h6v-2h-6v2ZM7,10h2v-2h-2v2Zm0,4h2v-2h-2v2Zm0,4h2v-2h-2v2Z"/>
                              </svg>
                              <span class="tooltiptext">VIEW DETAILS</span>
                            </li>
}
 
{/* {docState== "Error"&& issueResolved!==true ?                      
                     <li onClick={() => resolveDialog()}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.7 15.38">
            <g id="Layer_2" data-name="Layer 2"><path class="cls-1" d="M682.12,377.87" transform="translate(-673.99 -376.01)"/>
            <path class="cls-2" d="M681.05,376a2.55,2.55,0,0,0-1.54,1.09c-.53.88-5.15,8.87-5.15,8.87a2.32,2.32,0,0,0-.18,2.07,2.27,2.27,0,0,0,1.79,1.39c.62,0,5,0,5,0s.57-.25.54-.77a.82.82,0,0,0-.57-.68l-4.83,0s-.93-.37-.52-1.15c.59-1.12,5.31-9.13,5.31-9.13a.92.92,0,0,1,.61-.21.91.91,0,0,1,.62.31l3.14,5.44a.69.69,0,0,0,.61.24c.38-.06.75-.25.71-.69s-3.34-6-3.34-6a2.31,2.31,0,0,0-1.2-.77A2.78,2.78,0,0,0,681.05,376Z" transform="translate(-673.99 -376.01)"/>
            <rect class="cls-2" x="6.68" y="3.8" width="1.41" height="3.64" rx="0.7"/>
            <circle class="cls-2" cx="7.39" cy="9.24" r="0.91"/>
            <circle class="cls-3" cx="12.03" cy="11.71" r="3.17" style={{fill:"none", stroke:"#fff"}}/></g><g id="Layer_3" data-name="Layer 3">
              <path d="M685.83,387.84l1.36-1.29a.86.86,0,0,1,.4,0c.16.06.49.39.32.72a19.84,19.84,0,0,1-1.52,1.5,1.5,1.5,0,0,1-1.08.11,4,4,0,0,1-1.22-1.09.67.67,0,0,1,.13-.57.6.6,0,0,1,.58-.11A6.26,6.26,0,0,1,685.83,387.84Z" transform="translate(-673.99 -376.01)"/></g>
              </svg>
              <span class="tooltiptext">RESOLVE ISSUE</span>
                     </li>                     :                   
                    <li onClick={() => openDialog()}>
                      
                      <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
                    <path d="M10,23c0,.552-.448,1-1,1H5c-2.757,0-5-2.243-5-5V5C0,2.243,2.243,0,5,0H13c2.757,0,5,2.243,5,5v2c0,.552-.448,1-1,1s-1-.448-1-1v-2c0-1.654-1.346-3-3-3H5c-1.654,0-3,1.346-3,3v14c0,1.654,1.346,3,3,3h4c.552,0,1,.448,1,1ZM14,6c0-.552-.448-1-1-1H5c-.552,0-1,.448-1,1s.448,1,1,1H13c.552,0,1-.448,1-1ZM5,15c-.552,0-1,.448-1,1s.448,1,1,1h2c.552,0,1-.448,1-1s-.448-1-1-1h-2Zm19,2c0,3.86-3.14,7-7,7s-7-3.14-7-7,3.14-7,7-7,7,3.14,7,7Zm-2,0c0-2.757-2.243-5-5-5s-5,2.243-5,5,2.243,5,5,5,5-2.243,5-5Zm-5-4c-.828,0-1.5,.672-1.5,1.5s.672,1.5,1.5,1.5,1.5-.672,1.5-1.5-.672-1.5-1.5-1.5Zm0,4c-.552,0-1,.448-1,1v2c0,.552,.448,1,1,1s1-.448,1-1v-2c0-.552-.448-1-1-1Zm-7-6c0-.552-.448-1-1-1H5c-.552,0-1,.448-1,1s.448,1,1,1h4c.552,0,1-.448,1-1Z"/>
                  </svg>
                  <span class="tooltiptext">REPORT ISSUE</span>
                  </li>
                    } */}
     
            {/* <li onClick={() => exportCSV()}>
            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
  <path d="m22.535,6.122l-3.656-3.657c-.944-.944-2.2-1.464-3.536-1.464h-4.343c-2.206,0-4,1.794-4,4v5c0,.552.447,1,1,1s1-.448,1-1v-5c0-1.103.897-2,2-2h4v4c0,1.654,1.346,3,3,3h4v9c0,1.103-.897,2-2,2h-9c-1.103,0-2-.897-2-2v-1c0-.553-.447-1-1-1s-1,.447-1,1v1c0,2.206,1.794,4,4,4h9c2.206,0,4-1.794,4-4v-9.343c0-1.335-.521-2.591-1.465-3.535Zm-5.535.878v-3.502c.165.11.321.236.465.38l3.656,3.657c.142.142.268.298.377.464h-3.498c-.552,0-1-.449-1-1Zm-11,15c0,.553-.447,1-1,1h-1c-2.206,0-4-1.794-4-4V5C0,2.794,1.794,1,4,1h1c.553,0,1,.448,1,1s-.447,1-1,1h-1c-1.103,0-2,.897-2,2v14c0,1.103.897,2,2,2h1c.553,0,1,.447,1,1Zm-1-9h8.095l-1.802-1.793c-.391-.391-.391-1.024,0-1.415.391-.39,1.023-.39,1.414,0l2.799,2.801c.387.387.581.896.581,1.405,0,0,0,0,0,.001,0,0,0,0,0,.001,0,.509-.193,1.017-.58,1.404l-2.8,2.802c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.39-.391-1.023,0-1.414l1.792-1.793H5c-.553,0-1-.447-1-1s.447-1,1-1Z"/>
</svg>
<span class="tooltiptext">EXPORT DATA</span>
            </li> */}

            {/* { localStorage.getItem('master') && JSON.parse(localStorage.getItem('master')) &&
                          <li onClick={reprocessExtacted}>
                           <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
  <path d="m24,12c0,6.617-5.383,12-12,12-2.555,0-5.022-.814-7.066-2.305l-1.268,1.268c-.605.605-1.645.17-1.649-.689l-.018-4.314c-.002-.533.428-.962.96-.96l4.314.018c.859.004,1.294,1.044.689,1.649l-.869.869c1.452.947,3.15,1.464,4.907,1.464,4.963,0,9-4.038,9-9,0-.829.672-1.5,1.5-1.5s1.5.671,1.5,1.5Zm-21,0C3,7.038,7.038,3,12,3c1.769,0,3.463.51,4.913,1.458l-.876.876c-.605.605-.17,1.645.689,1.649l4.314.018c.532.002.962-.428.96-.96l-.018-4.314c-.003-.859-1.044-1.294-1.649-.689l-1.274,1.274c-2.041-1.492-4.488-2.311-7.06-2.311C5.383,0,0,5.383,0,12c0,.829.671,1.5,1.5,1.5s1.5-.671,1.5-1.5Zm13.642-.976l-.227.133c.052.274.085.555.085.844s-.033.57-.085.844l.227.133c.715.418.956,1.336.538,2.052-.279.478-.781.743-1.296.743-.258,0-.518-.066-.756-.205l-.243-.142c-.408.345-.873.617-1.385.799v.276c0,.829-.671,1.5-1.5,1.5s-1.5-.671-1.5-1.5v-.276c-.513-.183-.977-.455-1.385-.799l-.243.142c-.238.139-.499.205-.755.205-.516,0-1.018-.266-1.296-.743-.418-.715-.177-1.634.538-2.052l.227-.133c-.052-.274-.085-.555-.085-.844s.033-.57.085-.844l-.227-.133c-.715-.418-.956-1.336-.538-2.052.417-.716,1.336-.957,2.052-.538l.243.142c.408-.345.873-.617,1.385-.799v-.276c0-.829.671-1.5,1.5-1.5s1.5.671,1.5,1.5v.276c.513.183.977.455,1.385.799l.243-.142c.715-.418,1.632-.179,2.052.538.418.715.177,1.634-.538,2.052Zm-4.642-.524c-.827,0-1.5.673-1.5,1.5s.673,1.5,1.5,1.5,1.5-.673,1.5-1.5-.673-1.5-1.5-1.5Z"/>
</svg>
<span class="tooltiptext">REPROCESS EXTRACTED</span>
                          </li>

} */}
 
          </ul>
          <React.Fragment>
     

      <Dialog open={open} onClose={() => setOpen(false)} style={{ width: "40%", marginLeft: "30%" }}>
      <IconButton
    style={{ position: "absolute", top: "8px", right: "8px" }}
    onClick={() => setOpen(false)}
  >
    <CloseIcon />
  </IconButton>
        <DialogContent>
          <DialogContentText>
            <b style={{fontSize:'14px',color:'#000'}}>Please select the issue(s) you want to resolve:</b>
          </DialogContentText>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
  
  <div
    style={{
      maxHeight: "270px",
      overflowY: "auto",
      padding: "5px",
      scrollbarWidth: "thin", 
      scrollbarColor: "#888 transparent",
      border: "1px solid #ccc",
      borderRadius: "5px",
    }}
    className="custom-scrollbar"
  >
    {reportIsuueCells.length > 0 ? (
      <div style={{ display: "flex", flexDirection: "column",gap:'2px'}}>
        {reportIsuueCells.map((issue) => (
          <FormControlLabel
            key={issue.histId}
            control={
              <Checkbox
                style={{ transform: "scale(0.7)", marginRight: "5px" }}
                checked={selectissue.includes(issue.histId)}
                onChange={() => handleIssueSelection(issue.histId)}
              />
            }
            label={<span style={{ fontSize: "13px" }}>{issue.issue}</span>}
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              background: selectissue.includes(issue.histId) ? "#F9F9F9" : "transparent",            
              borderRadius: "4px",
            }}
          />
        ))}
      </div>
    ) : (
      <p style={{ fontSize: "13px", textAlign: "center" }}>No unresolved issues found.</p>
    )}
  </div>
</div>


        </DialogContent>
        <DialogActions
  style={{
    display: "flex",
    justifyContent: "space-between",  
    gap: "10px",  
  }}
>
  <Button
    onClick={handleSelectAll}
    style={resolve_popup_dialogBtn}
  >
    {selectissue.length === reportIsuueCells.length ? "Deselect All" : "Select All"}
  </Button>

  <Button onClick={handleConfirm} style={resolve_popup_dialogBtn} autoFocus    
  disabled={selectissue.length === 0}>
    Resolve
  </Button>
</DialogActions>

      </Dialog>
    </React.Fragment>

          {openReportIssue && <Dialog open={openReportIssue}
                          onClose={handleClose}>
                          <DialogTitle>Issue Detail</DialogTitle>
                          <DialogContent style={{ minWidth: 500 }}>
                            <DialogContentText>
                            <InputLabel htmlFor="outlined-basic" className='mt-3' style={{fontSize:'15px'}}>Enter Issue</InputLabel>

                              <TextField id="outlined-basic" value={enterIssue}   multiline={true} type="text" variant="outlined" style={{ width: "100%",marginTop:5 }}
                                // onChange={this.handleClickReportIssue}
                                onChange={e => setEnterIssue(e.target.value)}
                              />
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <div style={{ flexDirection: 'row' }}>
                            <Button style={cancel_dialogBtn} onClick={handleClose}>&times;</Button>
                              <Button style={submit_dialogBtn} onClick={submit} >Submit</Button>
                            </div>
                          </DialogActions>
                        </Dialog>}
        <SplitPane
              split="horizontal"
              minSize={70}
              defaultSize={parseInt(localStorage.getItem('splitPos'), 10)}
              onChange={(size) => {
                if (size < 1000) {
                  localStorage.setItem('splitPos', size)
                }
              }}
              style={{ position: "static", backgroundColor: 'transparent', marginTop:"60px" }}
            >
                  <div style={  
                   Isloader ? { ...pdfContentView, ...{ boxShadow: "none" } } : pdfContentView 
                  }>
                    <main className="Test__container__content" style={{marginTop:60}}>
<div style={{overflowY: "auto", overflowX: "hidden", height:"545px"}}>
                     {pdfImage ?

                      <Document
                      {...documentProps}
                        file={"data:application/pdf;base64," + pdfImage}
                      
                      >
                        <Page pageNumber={1} {...pageProps} />
                      </Document>

                      :
                      <p style={{color:"#fff"}}>loading PDF</p>

                    }
</div>
</main>
<div className='pdf_footer'>
<div className='date_format'>
      <span>Date/Time Received:</span>
      <h5>{moment(props.history&& props.history?.location && props.history?.location.state && props.history?.location.state.dateRec).format("MM/DD/YYYY hh:mm A")}</h5>
      </div>
      <div className='date_format'>
      <span>Date/Time Processed:</span>
      <h5>{moment( props.history&& props.history?.location && props.history?.location.state && props.history?.location.state.dateProcessed).format("MM/DD/YYYY hh:mm A")}</h5>
</div>
<div className='custom_pagination'>
  <p onClick={() => pageDownClicked()}><i class="fa fa-chevron-left" aria-hidden="true"></i></p>
  {[...Array(totalPages+1)].map((elementInArray, index) => (

((pageNo <= (totalPages - 3)) && (index >= pageNo && index <= (pageNo + 3)) && index != 0) ?
<p className={index== pageNo ? "active": "" } onClick={() => pageNumberClicked(index)}>
 {index}  
 </p>
:
(pageNo >= (totalPages - 3) && index >= (totalPages-3) && index <= totalPages && index != 0) &&
<p className={index== pageNo ? "active": "" } onClick={() => pageNumberClicked(index)}>
{index}
</p>
))}
<p>...</p>
<p onClick={() => pageNumberClicked(totalPages)}> Total Pages {history && history?.location && history?.location.state && history?.location.state.noOfPages}</p>
  <p onClick={() => pageUpClicked()}><i class="fa fa-chevron-right" aria-hidden="true"></i></p>
  <p onClick={() => pageNumberClicked(totalPages)}><i class="fa fa-step-forward" aria-hidden="true"></i>
  </p>
</div>
</div>
                  </div> 
            </SplitPane>
        
          <div className='pdf_tools'>
<span onClick={() => rotatePdfH(90)}>

<svg xmlns="http://www.w3.org/2000/svg" id="Isolation_Mode" data-name="Isolation Mode" viewBox="0 0 24 24" style={{rotate:"90deg"}}><path d="M20,19.056V4.925h3.989L19.461.4a1.376,1.376,0,0,0-1.944,0L12.989,4.925H17V19.056H12.96l4.546,4.54a1.379,1.379,0,0,0,1.951,0L24,19.056Z"/><path d="M0,3v8H11V0H3A3,3,0,0,0,0,3ZM3,3H8V8H3Z"/><path d="M0,21a3,3,0,0,0,3,3h8V13H0Zm3-5H8v5H3Z"/></svg>

</span>


<span onClick={() => rotatePdfV(0)}>

<svg xmlns="http://www.w3.org/2000/svg" id="Isolation_Mode" data-name="Isolation Mode" viewBox="0 0 24 24" width="512" height="512"><path d="M20,19.056V4.925h3.989L19.461.4a1.376,1.376,0,0,0-1.944,0L12.989,4.925H17V19.056H12.96l4.546,4.54a1.379,1.379,0,0,0,1.951,0L24,19.056Z"/><path d="M0,3v8H11V0H3A3,3,0,0,0,0,3ZM3,3H8V8H3Z"/><path d="M0,21a3,3,0,0,0,3,3h8V13H0Zm3-5H8v5H3Z"/></svg>

</span>



<span onClick={() => expandPdf()}>
    {expandScreen ?  
    <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" ><path d="M7.293,2.091,5.4,3.985,1.707.293A1,1,0,0,0,.293,1.707L3.985,5.4,2.091,7.293A1,1,0,0,0,2.8,9H7.564A1.436,1.436,0,0,0,9,7.564V2.8A1,1,0,0,0,7.293,2.091Z"/><path d="M20.015,18.6l1.894-1.894A1,1,0,0,0,21.2,15H16.436A1.436,1.436,0,0,0,15,16.436V21.2a1,1,0,0,0,1.707.708L18.6,20.015l3.692,3.692a1,1,0,0,0,1.414-1.414Z"/><path d="M16.436,9H21.2a1,1,0,0,0,.708-1.707L20.015,5.4l3.692-3.692A1,1,0,0,0,22.293.293L18.6,3.985,16.707,2.091A1,1,0,0,0,15,2.8V7.564A1.436,1.436,0,0,0,16.436,9Z"/><path d="M7.564,15H2.8a1,1,0,0,0-.708,1.707L3.985,18.6.293,22.293a1,1,0,1,0,1.414,1.414L5.4,20.015l1.894,1.894A1,1,0,0,0,9,21.2V16.436A1.436,1.436,0,0,0,7.564,15Z"/></svg>
  
      :
      <svg xmlns="http://www.w3.org/2000/svg" id="Bold" viewBox="0 0 24 24" ><path d="M22.5,15.5A1.5,1.5,0,0,0,21,17v1.5A2.5,2.5,0,0,1,18.5,21H17a1.5,1.5,0,0,0,0,3h1.5A5.506,5.506,0,0,0,24,18.5V17A1.5,1.5,0,0,0,22.5,15.5Z"/><path d="M7,0H5.5A5.506,5.506,0,0,0,0,5.5V7A1.5,1.5,0,0,0,3,7V5.5A2.5,2.5,0,0,1,5.5,3H7A1.5,1.5,0,0,0,7,0Z"/><path d="M7,21H5.5A2.5,2.5,0,0,1,3,18.5V17a1.5,1.5,0,0,0-3,0v1.5A5.506,5.506,0,0,0,5.5,24H7a1.5,1.5,0,0,0,0-3Z"/><path d="M18.5,0H17a1.5,1.5,0,0,0,0,3h1.5A2.5,2.5,0,0,1,21,5.5V7a1.5,1.5,0,0,0,3,0V5.5A5.506,5.506,0,0,0,18.5,0Z"/></svg>

    }
  </span>

  <span onClick={() => zoomIn()}>
  <svg xmlns="http://www.w3.org/2000/svg"  id="Bold"  viewBox="0 0 512 512" >
<path d="M288,192h-32v-32c0-17.673-14.327-32-32-32s-32,14.327-32,32v32h-32c-17.673,0-32,14.327-32,32s14.327,32,32,32h32v32  c0,17.673,14.327,32,32,32s32-14.327,32-32v-32h32c17.673,0,32-14.327,32-32S305.673,192,288,192z"/>
<path d="M502.661,457.569l-99.046-99.067c74.18-99.06,54.01-239.499-45.05-313.678S119.067-9.187,44.887,89.873  s-54.01,239.499,45.05,313.678c79.587,59.597,188.929,59.623,268.544,0.063l99.088,99.088c12.452,12.452,32.64,12.452,45.092,0  c12.452-12.452,12.452-32.64,0-45.092L502.661,457.569z M225.116,384.49c-88.02,0-159.374-71.354-159.374-159.374  S137.097,65.742,225.116,65.742s159.374,71.354,159.374,159.374C384.397,313.097,313.098,384.397,225.116,384.49z"/>
</svg>

  </span>
  <span onClick={() => zoomOut()}>
  <svg xmlns="http://www.w3.org/2000/svg"  id="Bold"  viewBox="0 0 512 512" >
<path d="M288,192H160c-17.673,0-32,14.327-32,32s14.327,32,32,32h128c17.673,0,32-14.327,32-32S305.673,192,288,192z"/>
<path d="M502.661,457.569l-99.046-99.067c74.18-99.06,54.01-239.499-45.05-313.678S119.067-9.187,44.887,89.873  s-54.01,239.499,45.05,313.678c79.587,59.597,188.929,59.623,268.544,0.063l99.088,99.088c12.452,12.452,32.64,12.452,45.092,0  c12.452-12.452,12.452-32.64,0-45.092L502.661,457.569z M225.116,384.49c-88.02,0-159.374-71.354-159.374-159.374  S137.097,65.742,225.116,65.742s159.374,71.354,159.374,159.374C384.397,313.097,313.098,384.397,225.116,384.49z"/>
</svg>
  </span>
  <span onClick={() => resetPdf()}>
  <svg xmlns="http://www.w3.org/2000/svg"  id="Capa_1"  viewBox="0 0 513.806 513.806">
<g>
	<path d="M66.074,228.731C81.577,123.379,179.549,50.542,284.901,66.045c35.944,5.289,69.662,20.626,97.27,44.244l-24.853,24.853   c-8.33,8.332-8.328,21.84,0.005,30.17c3.999,3.998,9.423,6.245,15.078,6.246h97.835c11.782,0,21.333-9.551,21.333-21.333V52.39   c-0.003-11.782-9.556-21.331-21.338-21.329c-5.655,0.001-11.079,2.248-15.078,6.246L427.418,65.04   C321.658-29.235,159.497-19.925,65.222,85.835c-33.399,37.467-55.073,83.909-62.337,133.573   c-2.864,17.607,9.087,34.202,26.693,37.066c1.586,0.258,3.188,0.397,4.795,0.417C50.481,256.717,64.002,244.706,66.074,228.731z"/>
	<path d="M479.429,256.891c-16.108,0.174-29.629,12.185-31.701,28.16C432.225,390.403,334.253,463.24,228.901,447.738   c-35.944-5.289-69.662-20.626-97.27-44.244l24.853-24.853c8.33-8.332,8.328-21.84-0.005-30.17   c-3.999-3.998-9.423-6.245-15.078-6.246H43.568c-11.782,0-21.333,9.551-21.333,21.333v97.835   c0.003,11.782,9.556,21.331,21.338,21.329c5.655-0.001,11.079-2.248,15.078-6.246l27.733-27.733   c105.735,94.285,267.884,85.004,362.17-20.732c33.417-37.475,55.101-83.933,62.363-133.615   c2.876-17.605-9.064-34.208-26.668-37.084C482.655,257.051,481.044,256.91,479.429,256.891z"/>
</g>
</svg>
  </span>
  <a onClick={() => downloadPdf()}>
  <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1"  viewBox="0 0 24 24" ><path d="m19.949,5.536l-3.484-3.486c-1.323-1.322-3.081-2.05-4.95-2.05h-4.515C4.243,0,2,2.243,2,5v14c0,2.757,2.243,5,5,5h10c2.757,0,5-2.243,5-5v-8.515c0-1.871-.729-3.628-2.051-4.95Zm-1.414,1.415c.318.317.587.67.805,1.05h-4.341c-.552,0-1-.449-1-1V2.659c.38.218.733.487,1.051.805l3.484,3.486Zm1.465,12.05c0,1.654-1.346,3-3,3H7c-1.654,0-3-1.346-3-3V5c0-1.654,1.346-3,3-3h4.515c.163,0,.325.008.485.023v4.977c0,1.654,1.346,3,3,3h4.977c.015.16.023.322.023.485v8.515Zm-4.293-2.895c.391.39.391,1.023,0,1.414l-1.613,1.614c-.577.577-1.336.866-2.094.866s-1.517-.289-2.094-.866l-1.613-1.614c-.391-.391-.391-1.024,0-1.414.391-.391,1.023-.391,1.414,0l1.293,1.293v-4.398c0-.552.447-1,1-1s1,.448,1,1v4.398l1.293-1.293c.391-.391,1.023-.391,1.414,0Z"/></svg>

    </a>
  <span style={zoomRotate_Icon}>
    </span>         
          </div>
      </div>
                       <div style={bottom_View}>
               {Object.keys(finalDataResult).length > 0 ?
                <Grid >
                <div className='csv_file_icon'> 
                  {history?.location.state.final_filenames!==undefined?(<>
                 { history?.location.state.final_filenames.length>0&&
                   <select
                   style={{
  marginTop: '10px',
  marginBottom: '5px',
  padding:'7px',
  border: 'none',
  backgroundColor: 'rgb(255, 255, 255)',
  boxShadow: 'rgba(0, 0, 0, 0.4) 1px 1px 3px',
  borderRadius:'5px'  ,
  fontSize:'11px',
  fontWeight:'600',
}}
             onChange={(e)=>{
              setCsvFileName(e.target.value)
              geCsvData(e.target.value)
            }}
            >
            {history?.location.state.final_filenames.map((curr, index) => {
              return (
                <>
                  <option >{curr}</option>
                </>
              );
            })}
           </select> 
       } </>):''}
   
        {/* <Button 
  style={resolve_dialogBtn} 
  onClick={() => openDialog()} 
    
>
  Report Issue
</Button> */}
<Button 
  style={resolve_dialogBtn} 
  onClick={handleReportIssue}
>
  Report Issue
</Button>

       <Button style={resolve_dialogBtn}  onClick={() => setOpenDialog(true)}>Issue History</Button>
    
       <Button style={resolve_dialogBtn} onClick={() => resolveDialog()} >Resolve Issue</Button>
        {/* { localStorage.getItem('master') && JSON.parse(localStorage.getItem('master')) &&
       <Button style={resolve_dialogBtn} onClick={reprocessExtacted}>Reprocess Extracted  </Button>
       } */}
       <Button style={resolve_dialogBtn} onClick={() => validateData()}>Validate</Button>
        <Button style={resolve_dialogBtn} onClick={() => exportCSV()}>Export Data</Button>
  
     </div>
    
                <Grid item xs={12} style={{ marginTop: 0}}>
                <GroupPanel className="group-panel" grid={gridObject} placeholder="Drag columns here to create groups"/> 
                <FlexGrid
                      headersVisibility="Column"
                      autoGenerateColumns={false}
                      isReadOnly={true}
                      itemsSource={finalDataResult}
                      initialized={(s)=>initializeGrid(s,docState=="Error"?false:true,reportIsuueCells)}                   
                      style={{
                        height: "auto",
                        maxHeight: 400,
                        marginB: 10,
                      }}

                      selectionMode="MultiRange"
                      showSelectedHeaders="All"

                       selectionChanged={(s) => {
                         let ranges = s.selectedRanges;
                       
                        let rangescpy = []
                        for (let i = 0; i < ranges.length; i++) {
                          let newRows = {}

                          let rng = ranges[i];
                          newRows["topRow"] = rng.topRow
                          newRows["bottomRow"] = rng.bottomRow
                          newRows["leftCol"] = rng.leftCol
                          newRows["rightCol"] = rng.rightCol
                          rangescpy.push(newRows)
                      
                        }
                           console.log(":::rangescpy",rangescpy)
                          setSelectedReportIssueCells(rangescpy)
                          setSelectresolveissue([]);
 
                      }}
                      >
                   
                      {finalDataResult.length>0 && Object.keys(finalDataResult[0]).map(key =>
                       <FlexGridColumn
                      binding={key}
                      header={key}
                      cssClass="cell-header"
                      width="*"
                      minWidth={100}
                       style={{backgroundColor:'grey'}}
                      >
 
                      </FlexGridColumn>
                      )}  

                      <wjFilter.FlexGridFilter></wjFilter.FlexGridFilter>
                    </FlexGrid>
                </Grid>
              </Grid>:
              <div style={{width: "100%", display: "block", position: "relative", top: 70}}>
        <p style={{ color: "#c00",  textAlign: "center", fontSize: "1.6em" }}>
               {(!isCsvLoading) ? "No record Found!!" : ""}
             </p>
  </div>
              }
              </div>     
           {isCsvLoading ? 
            <center className='mt-5'><CircularProgress /></center>
            :
           openValidateData &&
            <Dialog open={openValidateData}
            onClose={handleValidateClose}>
            <DialogTitle style={{fontWeight:'bold',fontSize:18}}>Validate Data</DialogTitle>
            <DialogContent style={{ minWidth: 500 }}>
              <DialogContentText>
                <CCard>
                <CCardBody>
                <CRow>
                <CCol sm="4" style={{fontWeight:'bold',fontSize:15}}>Validated:</CCol>
                <CCol sm="1"></CCol>
                <CCol sm="7">{!validData["Validated"] ? <i class="fa fa-times" aria-hidden="true"></i>:<i class="fa fa-check" aria-hidden="true"></i>}</CCol>
                </CRow>
                <CRow>
                <CCol sm="4" style={{fontWeight:'bold',fontSize:15}}>Check Amount :</CCol>
                <CCol sm="1"></CCol>
                <CCol sm="7">{validData["Check Amount"]}</CCol>
                </CRow>
                <CRow>
                <CCol sm="4" style={{fontWeight:'bold',fontSize:15}}>Tax Deduct Totals:</CCol>
                <CCol sm="1"></CCol>
                <CCol sm="7">{validData["Tax Deduct Totals"]}</CCol>
                </CRow>
                <CRow>
                <CCol sm="4" style={{fontWeight:'bold',fontSize:15}}>Net Deduct Total :</CCol>
                <CCol sm="1"></CCol>
                <CCol sm="7">{validData["Net Deduct Total"]}</CCol>
                </CRow>
                <CRow>
                <CCol sm="4" style={{fontWeight:'bold',fontSize:15}}>Net Tax Total:</CCol>
                <CCol sm="1"></CCol>
                <CCol sm="7">{validData["Net Tax Total"]}</CCol>
                </CRow>
                <CRow>
                <CCol sm="4" style={{fontWeight:'bold',fontSize:15}}>Owner Deducts:</CCol>
                <CCol sm="1"></CCol>
                <CCol sm="7">{validData["Owner Deducts"]}</CCol>
                </CRow>
                <CRow>
                <CCol sm="4" style={{fontWeight:'bold',fontSize:15}}>Owner Taxes:</CCol>
                <CCol sm="1"></CCol>
                <CCol sm="7">{validData["Owner Taxes"]}</CCol>
                </CRow>
                <CRow>
                <CCol sm="4" style={{fontWeight:'bold',fontSize:15}}>Owner Value:</CCol>
                <CCol sm="1"></CCol>
                <CCol sm="7">{validData["Owner Value"]}</CCol>
                </CRow>
                </CCardBody>
                </CCard>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <div style={{ flexDirection: 'row' }}>
                <Button style={cancel_dialogValidateBtn} onClick={handleValidateClose}>Cancel</Button>
              </div>
            </DialogActions>
          </Dialog>
          }
          {(Isloader) &&
            <div style={loader}>

              <CircularProgress style={{ margin: "26% auto", display: "block" }} />

            </div>
          }
          <div>
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
 
          </div>
  {/* <IssueHistoryData/> */}
  <IssueHistoryData open={openDialogs} issueHistoryData={issueHistoryData} handleClose={() => setOpenDialog(false)} />
      </> 
      
  );
  
}
export default withStyles(doc_styles, { withTheme: true })(DocumentDetails);
